import { Box, Group, Indicator } from '@mantine/core';
// eslint-disable-next-line prettier/prettier
import { IconFiles, IconInbox, IconLayoutSidebarRightCollapse, IconUser } from '@tabler/icons';
import { useContext } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useDisclosure } from '@mantine/hooks';
import { useNavigationItem } from '../../../Organismns/Navigation/NavigationItemHook';
import { PostboxCountersContext } from '../../../Service/Context/PostboxCountersContext';
import NavDrawer from '../../../Atoms/NavDrawer';
import ContactTile from '../../Contacts/ContactPage/ContactTile';
import ContactNavBar from '../../Contacts/ContactPage/ContactNavBar';
import ActionIconWithText from './ActionIconWithText';

const ContactDetailsFooter = () => {
  const navigate = useNavigate();
  const [opened, { close, open }] = useDisclosure(false);
  const { id: contactId } = useParams();
  const { unreadCount } = useContext(PostboxCountersContext);

  return (
    <>
      <Group px="xl" pt={5} sx={{ justifyContent: 'space-between' }}>
        <ActionIconWithText label="Alle" onClick={open}>
          <IconLayoutSidebarRightCollapse />
        </ActionIconWithText>
        <ActionIconWithText
          label="Details"
          active={useNavigationItem(`/contacts/${contactId}/details`)}
          onClick={() => navigate(`/contacts/${contactId}/details`)}
        >
          <IconUser />
        </ActionIconWithText>
        <ActionIconWithText
          label="Dateien"
          active={useNavigationItem(`/contacts/${contactId}/documents`)}
          onClick={() => navigate(`/contacts/${contactId}/documents`)}
        >
          <IconFiles />
        </ActionIconWithText>
        <Indicator color="red" label={unreadCount} radius="xl" size={20} disabled={!unreadCount || unreadCount === 0}>
          <ActionIconWithText
            label="Mails"
            active={useNavigationItem(`/contacts/${contactId}/emails`)}
            onClick={() => navigate(`/contacts/${contactId}/emails/inbox`)}
          >
            <IconInbox />
          </ActionIconWithText>
        </Indicator>
      </Group>
      <NavDrawer opened={opened} onClose={close}>
        <Box
          p="md"
          sx={{
            fontSize: 16,
          }}
        >
          <ContactTile />
        </Box>
        <ContactNavBar closeNavBar={close} />
      </NavDrawer>
    </>
  );
};

export default ContactDetailsFooter;
